import { z } from 'zod';
import { opgavekompleksetInputEntrySchema } from './_inputs.js';

const opgavekompleksetTaskEntrySchema = z.object({
  id: z.string(),
  state: z.object({
    attempts: z.number().default(0),
    validated: z.boolean().default(false),
    opened: z.boolean().default(false),
    closed: z.boolean().default(false),
    skipped: z.boolean().default(false)
  }),
  stats: z.object({
    correct: z.number().default(0),
    wrong: z.number().default(0),
    total: z.number().default(0)
  }),
  details: z.union([z.record(z.string(), opgavekompleksetInputEntrySchema),
  // transformer for legacy details sturcture
  z.union([z.array(z.any()), z.record(z.any(), z.any()).transform(it => [it])]), z.record(z.string(), z.preprocess(arg => JSON.parse(arg), z.object({
    details: z.union([z.array(z.any()), z.record(z.any(), z.any()).transform(it => [it])])
  }))).transform(it => ({
    __legacyStack: true,
    tasks: it
  }))])
});

export { opgavekompleksetTaskEntrySchema };
//# sourceMappingURL=_entry-data.js.map
